/**
 * 首頁骨架屏：/home 尚未回來時佔位。
 *
 * 刻意只畫版面形狀、不畫任何數值 —— 先顯示上一次的天數會讓使用者以為那是最新結果，
 * 所以寧可留白。比起空白轉圈，形狀先到位可以讓等待感覺短一些，資料回來時也不會整頁跳版。
 */

const BASE = "#e3e8ef";
const HIGHLIGHT = "#eef2f7";

const shimmer = `
@keyframes homeSkeletonShimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
@media (prefers-reduced-motion: reduce) {
  .home-sk { animation: none; }
}
`;

const Block = ({
  height,
  width = "100%",
  radius = 10,
  style,
}: {
  height: number;
  width?: number | string;
  radius?: number;
  style?: React.CSSProperties;
}) => (
  <div
    className="home-sk"
    style={{
      height,
      width,
      borderRadius: radius,
      background: `linear-gradient(90deg, ${BASE} 25%, ${HIGHLIGHT} 37%, ${BASE} 63%)`,
      backgroundSize: "200% 100%",
      animation: "homeSkeletonShimmer 1.4s ease-in-out infinite",
      ...style,
    }}
  />
);

export const HomeSkeleton = () => (
  <div
    role="status"
    aria-live="polite"
    aria-label="首頁載入中"
    style={{
      width: "100%",
      height: "100%",
      overflow: "hidden",
      background: "#f8fafc",
      padding: "16px 16px 24px",
      display: "flex",
      flexDirection: "column",
      gap: 16,
    }}>
    <style>{shimmer}</style>

    {/* 智慧預測 Hero */}
    <div
      style={{
        background: "#fff",
        borderRadius: 18,
        padding: 18,
        display: "flex",
        flexDirection: "column",
        gap: 14,
      }}>
      <Block height={13} width="38%" radius={6} />
      <Block height={34} width="62%" radius={8} />
      <Block height={10} width="100%" radius={999} />
      <div style={{ display: "flex", gap: 10 }}>
        <Block height={12} width="28%" radius={6} />
        <Block height={12} width="28%" radius={6} />
      </div>
    </div>

    {/* 主要行動按鈕 */}
    <Block height={52} radius={14} />

    {/* 功能卡片列 */}
    <div style={{ display: "flex", gap: 12 }}>
      <Block height={92} radius={14} />
      <Block height={92} radius={14} />
    </div>

    {/* 資訊區塊 */}
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      <Block height={13} width="30%" radius={6} />
      <Block height={64} radius={14} />
    </div>
  </div>
);

export default HomeSkeleton;
